import { axiosInstance } from '../axios';
import type { PaginatedResponse, ApiResponse } from '../../types/common';
import type {
  TenantAuditLogDto,
  EntityAuditLogDto,
  GetAuditLogsParams,
  GetEntityAuditParams,
} from '../../types/auditLog';

export const auditLogsApi = {
  getTenantLogs: (params: GetAuditLogsParams) =>
    axiosInstance.get<PaginatedResponse<TenantAuditLogDto>>('/v1/product-admin/audit-logs/tenant', {
      params,
    }),

  getEntityLogs: (params: GetEntityAuditParams) =>
    axiosInstance.get<PaginatedResponse<EntityAuditLogDto>>('/v1/product-admin/audit-logs/entity', {
      params,
    }),

  exportCsv: (params: GetAuditLogsParams) =>
    axiosInstance.get('/v1/product-admin/audit-logs/export', {
      params,
      responseType: 'blob',
    }),
};
